/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'react',
	'prop-types',
	'./internal/FontPropTypes',
	'./internal/TextFormatView'
], function (React, PropTypes, FontPropTypes, TextFormatView) {

	const {
		TextPropType,
		FontOptionsPropType,
		ColorOptionsPropType,
		DefaultStatePropType
	} = FontPropTypes;

	class TextFormatComponent extends React.Component {
		static propTypes = {
			state: TextPropType,
			onStateChange: PropTypes.func.isRequired,
			onClose: PropTypes.func.isRequired,
			supportsStyleAndAlignment: PropTypes.bool,
			supportsTextWrap: PropTypes.bool,
			colorOptions: ColorOptionsPropType.isRequired,
			fontOptions: FontOptionsPropType.isRequired,
			fontSizeOptions: FontOptionsPropType.isRequired,
			defaultState: DefaultStatePropType.isRequired
		};

		constructor(props) {
			super(props);
			this.state = { ...props.state };
		}

		render() {
			return (
				<TextFormatView
					state={this.state}
					onStateChange={newState => this.onStateChange(newState)}
					onClose={this.props.onClose}
					supportsStyleAndAlignment={this.props.supportsStyleAndAlignment}
					supportsTextWrap={this.props.supportsTextWrap}
					colorOptions={this.props.colorOptions}
					fontOptions={this.props.fontOptions}
					fontSizeOptions={this.props.fontSizeOptions}
					defaultState={this.props.defaultState}
				/>
			);
		}

		onStateChange(newState) {
			this.setState(newState);
			this.props.onStateChange(newState);
		}
	}

	return TextFormatComponent;
});
